define('services/outbound/fileReaderUtils',[
    '../../lib/bluebird',
    'lib/lodash4',
    //no references required
    'lib/papaparse'
], function (
    Promise,
    _,
    Papa
) {
    'use strict';


    var fileReaderUtils = {
        readFileContents: function (uploadFile) {
            var fileReader = new FileReader();

            return new Promise(function (resolve, reject) {
                //create a closure to keep state
                fileReader.onload = (function (uploadFile) {
                    return function (res) {
                        var fileContents = res.target.result;

                        resolve({ uploadFile: uploadFile, fileContents: fileContents });
                    };
                })(uploadFile);

                fileReader.onerror = function (err) {
                    reject(err);
                };

                fileReader.readAsText(uploadFile, 'UTF-8');
            });
        },


        readFileChunk: function (uploadFile, chunkSize) {
            var fileReader = new FileReader();

            return new Promise(function (resolve, reject) {
                fileReader.onloadend = (function (uploadFile) {
                    return function (res) {
                        var fileChunk = res.target.result;

                        resolve({ uploadFile: uploadFile, fileChunk: fileChunk });
                    };
                })(uploadFile);

                fileReader.onerror = function (err) {
                    reject(err);
                };

                fileReader.readAsBinaryString(uploadFile.slice(0, chunkSize));
            });
        },


        csvToArray: function (fileChunk) {
            //convert all \r to \n to get a common eol
            //they will be ignored during line parsing that is already obligated to check for empty ,,,, lines
            var eolNormalized = fileChunk.replace(/\r/g, '\n').replace(/(\n)+/g, '\n');

            //break down chunk into rows by newline
            var rows = eolNormalized.split('\n');

            //rows that are not empty will be stored here
            var scrubbed = [];

            _.each(rows, function (row) {
                var clean = row.replace(/[\s\"\']/g, '').replace(/\t/g, '');
                var columns = clean.split(',');

                //There are two states to verify 'empty'
                //is clean an empty string after the replace
                //is the line full of commas with nothing in them - thus clean's length + 1 is equal to the split length
                if (!_.isEmpty(clean) && clean.length + 1 !== columns.length) {
                    scrubbed.push(row);
                }
            });

            return scrubbed;
        },

        getCsvHeaders: function (csvData, csvToArray) {
            var rows = csvData;
            if (csvToArray) {
                rows = fileReaderUtils.csvToArray(csvData);
            }
            if (rows && rows.length > 0) {
                var headers = rows[0].replace(/\"/g, '').split(',');
                return _.forEach(headers, function (columnName, index, arr) {
                    arr[index] = columnName.toLowerCase();
                    arr[index] = columnName.trim();
                });
            }
            return [];
        },

        getFirstDataRowColumns: function (csvData, csvToArray) {
            var rows = csvData;
            if (csvToArray) {
                rows = fileReaderUtils.csvToArray(csvData);
            }
            if (rows.length === 0) {
                return [];
            }
            if (rows.length === 1) {
                var columns = rows[0].replace(/\"/g, '').split(',');
                return _.forEach(columns, function (columnName, index, arr) {
                    arr[index] = columnName.trim();
                });
            }
            return rows[1].replace(/\"/g, '').split(',');
        },

        getUniqueCsvColumnValuesFromFile: function (file, columnIndex, progressCallback) {
            columnIndex = columnIndex || 0;
            return new Promise(function (resolve, reject) {
                var uniqueValues = [];
                var errors = [];

                var config = {
                    delimiter: ',',
                    chunk: function (res) {
                        if(progressCallback) {
                            progressCallback(res);
                        }
                        _.forEach(res.data, function (row) {
                            if (!_.includes(uniqueValues, row[columnIndex])) {
                                uniqueValues.push(row[columnIndex]);
                            }
                        });
                        _.forEach(res.errors, function (error) {
                            errors.push(error);
                        });
                    },
                    complete: function () {
                        if (errors.length > 0) {
                            reject(errors);
                        } else {
                            resolve(uniqueValues);
                        }
                    }
                };

                Papa.parse(file, config);
            })
            .then(function (res) {
                res.shift();
                return res;
            });
        }
    };

    return fileReaderUtils;
});

